import React from 'react';
import styled from '@emotion/styled';
import { mediaQueries } from 'components/mediaQueries';
import { Category } from 'data/SingleArticle/types';
import { CommonLinkText } from 'components/typography';
import paths from 'constants/paths';
import { Link } from 'components/Link/Link';
import { Icon } from '@zapier/design-system';

type Props = {
  breadcrumbs: Category[];
};

const ArrowIcon = (props: { hideOnMobile?: boolean }) => {
  return (
    <ArrowIconListItem hideOnMobile={props.hideOnMobile}>
      <Icon name="arrowSmallRight" size={20} color="neutral600" />
    </ArrowIconListItem>
  );
};

export const Breadcrumbs: React.FC<Props> = ({ breadcrumbs }: Props) => {
  return (
    <>
      <List qty={breadcrumbs.length}>
        <ListItem key={'home'}>
          <Link href={paths.basePath}>
            <BreadcrumbLinkText>Home</BreadcrumbLinkText>
          </Link>
        </ListItem>
        <ArrowIcon />
        {breadcrumbs.map((category, categoryIndex) => (
          <>
            <ListItem key={category.slug}>
              <Link href={paths.categoryHome(category.slug)}>
                <BreadcrumbLinkText>{category.title}</BreadcrumbLinkText>
              </Link>
            </ListItem>
            {categoryIndex !== breadcrumbs.length - 1 && (
              <ArrowIcon hideOnMobile={true} />
            )}
          </>
        ))}
      </List>
    </>
  );
};

const List = styled.ul<{ qty: number }>`
  display: none;
  ${mediaQueries.tablet} {
    display: flex;
    justify-self: start;
    align-items: center;
    margin: 20px 15px 20px 0;
    margin-left: 20px;
  }
  ${mediaQueries.desktop} {
    margin-left: 32px;
  }
`;

const ListItem = styled.li`
  font-weight: 600;
  display: none;
  position: relative;

  /** Breadcrumb link, is the only one that should be shown in mobile */
  &:last-of-type {
    display: block;

    &:before {
      margin-right: 6px;
    }
  }

  &:first-of-type {
    margin-left: 0;

    &:before {
      display: none;
    }
  }

  ${mediaQueries.tablet} {
    display: block;
    &:last-of-type {
      margin-right: 0;
    }
  }
`;

const ArrowIconListItem = styled.li<{ hideOnMobile?: boolean }>`
  height: 20px;
  transform: rotate(180deg);
  display: ${({ hideOnMobile }) => (hideOnMobile ? 'none' : 'block')};

  ${mediaQueries.tablet} {
    transform: none;
    display: block;
  }
`;

const BreadcrumbLinkText = styled(CommonLinkText)`
  display: inline;
`;
